/* global Cleave */
if ($('.sign-up input[name="phone"]').length) {
    let input = $('.sign-up input[name="phone"]');

    let country = $('.sign-up [name="phone_country"]').val();
    if (country) {
        new Cleave(input[0], {
            phone: true,
            phoneRegionCode: country
        });
    }
}

$('body').on('change', '.sign-up [name="phone_country"]', function() {
    let input = $('.sign-up input[name="phone"]');

    let country = $('.sign-up [name="phone_country"]').val();
    if (country) {
        new Cleave(input[0], {
            phone: true,
            phoneRegionCode: country
        });
    }
    
    return false;
});

if ($('.sign-up input[name="confirm_phone"]').length) {
    console.log('test');
    let input = $('.sign-up input[name="confirm_phone"]');

    let country = $('.sign-up [name="confirm_phone_country"]').val();
    if (country) {
        new Cleave(input[0], {
            phone: true,
            phoneRegionCode: country
        });
    }
}

$('body').on('change', '.sign-up [name="confirm_phone_country"]', function () {
    let input = $('.sign-up input[name="confirm_phone"]');

    let country = $('.sign-up [name="confirm_phone_country"]').val();
    if (country) {
        new Cleave(input[0], {
            phone: true,
            phoneRegionCode: country
        });
    }

    return false;
});

$('body').on('click', '.add-single-trigger', function () {
    // get the limit
    var limit = parseInt($(".singles").attr("data-limit"));
    var count = $(".singles .setup-singles .single").length;

    // if less then the limit add the sigle
    if(count < limit) {
        $(".singles .setup-singles").append(`<div class="single">
            <a href="" class="remove-single icon-trash"></a>
            <ul class="fields">
                <li class="third">
                    <input type="text" name="name[]" class="required">
                    <span>Name</span>
                </li>

                <li class="filled third">
                    <select name="ben_bas[]" class="required">
                        <option value="">Select</option>
                        <option value="Ben">Ben</option>
                        <option value="Bas">Bas</option>
                    </select>
                    <span>Ben/Bas</span>
                </li>

                <li class="third last">
                    <input type="text" name="mother[]" class="required">
                    <span>Mother</span>
                </li>
            </ul>
        </div>`);
    }

    // if == the limit hide the button
    if ($(".singles .setup-singles .single").length >= limit) {
      $(".add-single-wrapper").hide();
    }

    return false;
});

$('body').on('click', '.remove-single', function() {
    $(this).parents('.single').remove();
    $(".add-single-wrapper").show();
    return false;
});


// submitting the sign-up form
$('body').on('submit', '.sign-up form', function () {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: "_token", value: $('meta[name="csrf-token"]').attr("content") };

    var error = false;
    $('.sign-up').find('.required').each(function () {
        var input = $(this);
        input.removeClass('error');

        if (input.attr('type') === 'radio') {
            if (!$('.sign-up').find('input[name="' + input.attr('name') + '"]:checked').length) {
                error = true;
            }
        }

        if (input.attr('type') === 'checkbox') {
            if (!input.prop('checked')) {
                error = true;
            }
        }

        if (input.val() === '') {
            input.addClass('error');
            error = true;
        }
    });

    if (error) {
        $('.sign-up .message').show().html('Please fill out all required fields');
        return false;
    }

    loading('Processing...');
    $('.sign-up input').prop('disabled', true);
    $('.sign-up .message').show().html('Processing');

    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            unloading();
            // console.log(data);
            $('.sign-up input').prop('disabled', false);
            if (data.success) {
                $('.sign-up form')[0].reset();

                $('.signup-modal .message').html(data.message);

                var scrollTop = $(window).scrollTop();
                $('.signup-modal').css({
                    'top': (scrollTop - 500) + 'px'
                });

                setTimeout(function () {
                    $('.signup-modal').addClass('visible');
                }, 100);
                $('.signup-overlay').addClass('visible');
                return false;
            }

            $('.sign-up .message').show().html(data.message);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});

// close the modal
$('body').on('click', '.close-signup-modal', function() {
    $('.signup-modal').removeClass('visible');
    $('.signup-overlay').removeClass('visible');
    return false;
});


$('body').click(function (e) {
    if ($(e.target).attr('class') === 'signup-overlay visible') {
        $('.signup-modal').removeClass('visible');
        $('.signup-overlay').removeClass('visible');
    }
});